import React, { Component } from "react";
import MainLinkList from "./main-link-list";
import SecondaryLinkList from "./secondary-link-list";
import SocialMedia from "./social-media";
import InternalLinks from "./internal-links";
import MainLogo from "./main-logo";
import SkipLink from "./skip-link";

class Footer extends Component {
  constructor() {
    super();
  }

  render() {
    const { footerProps } = this.props;
    if (!footerProps || process.env.NEXT_PUBLIC_WEB_VIEW === "true") {
      return null;
    }

    const mediaLinks = footerProps["media-links"];

    return (
      <>
        <footer className="footer" aria-label="Pie de página">
          <SkipLink></SkipLink>
          <div className="block-1">
            <nav aria-label="Menú">
              <MainLinkList data={footerProps["main-link-list"]} />
            </nav>
          </div>
          <div className="block-2">
            <div className="content container">
              <div className="media-container">
                <nav aria-label="Redes sociales">
                  <SocialMedia data={mediaLinks["social-media"]} />
                </nav>
              </div>
              <span className="separator-horizontal" />
              <nav aria-label="Vínculos corporativos">
                <SecondaryLinkList data={footerProps["secondary-link-list"]} />
              </nav>
              <span className="separator-horizontal" />
              <div className="internal-links">
                <InternalLinks internalLinks={mediaLinks["internal-links"]} />
              </div>
              <span className="separator-horizontal" />
              <MainLogo {...mediaLinks["main-logo"]} />
            </div>
          </div>
          <style jsx>{`.footer {
  margin-top: 1.5rem;
  .block-1 {
    background-color: #FFFAF5;
  }
  .block-2 {
    background-color: #0066FF;
  }
  .block-2 .content .media-container .separator-container {
    margin-top: 0.75rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .block-2 .content .separator-horizontal {
    display: block;
    margin: 0 auto;    
    border-top: 1px solid rgba(255, 255, 255, 0.5);
  }
  .block-2 .content .internal-links {
    display: block;
    margin: 0 auto;    
    padding: 0 0;
  }
  @media screen and (min-width: 768px) {
    .block-2 .content .media-container {
      display: flex;
      flex-flow: row nowrap;
      justify-content: center;
      align-items: center;
      gap: 1.5rem;
      padding-top: 1rem;
      padding-bottom: 1rem;
      position: relative;
      margin: 0 auto;
    }    
  }
  @media screen and (min-width: 1024px) {
    .block-2 .content .media-container .separator-container {
      display: block !important;
      align-self: stretch;
      width: 1px;
      margin: 0 !important;
      background-color: white;
    }
    .block-2 .content .media-container .separator-container > span {
      background-color: transparent !important;
    }
  }
}
`}</style>
        </footer>
      </>
    );
  }
}

export default Footer;
